export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'Haai - HAAI学堂',
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://api.hmdev.net/',
    pro: 'https://api.haai.net/'
  },
  proxyTable: {
    '/': {
      target: 'http://api.hmdev.net/',
      changeOrigin: true, // 开启代理
      // pathRewrite: {
      //   '^/v2api': '/v2api'
      // }
    }
  },
  accessToken: 'haimakid_token',
  refreshToken: 'haimakid_refresh_token',
  domain: process.env.NODE_ENV === 'production' ? '.haai.net':'localhost',
  role: 'role',
  scratchUrl: process.env.NODE_ENV === 'production'?'https://shequ.haai.net/scratch':'https://shequ.haai.net/scratch',
  shequUrl: process.env.NODE_ENV === 'production'?'https://shequ.haai.net':'/',
  // matchHost: process.env.NODE_ENV === 'production'?'https://match.haimakid.net/':'http://localhost:9091/'
}
